export enum LabelPosition {
	Left = 'left',
	LeftAligned = 'left-aligned',
	TopStacked = 'top-aligned-stacked',
	TopAlign = 'top-aligned-inline',
	TopLeftAlign = 'top-left-aligned',
}
